import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { sportsEloHelpers } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/eloInfo'
import React, { useContext, useMemo } from 'react'

export const TeamInsight = ({ team }) => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { matches_info, teams_info } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}
  const { section_info } = matches_info ?? {}
  const { sectionStats } = section_info ?? {}

  const teamInsights = useMemo(() => {
    return team?.record?.eloInfo
  }, [team])

  const teamReason = useMemo(() => {
    const { record } = team ?? {}
    const { eloInfo } = record ?? {}
    const { elo } = eloInfo ?? {}
    const eloDelta = 1500 + elo
    return sportsEloHelpers.getTeamRankingReason({ teamId: team?._itemKey, teams, eloInfo, sectionStats, eloDelta })
  }, [team])

  const div_reason = () => _.map(teamReason, tr => (
    <div style={{ padding: '.5em' }}>{tr}</div>
  ))

  const fnMainContent = (item) => {
    const { itemKey, caption, item: itemItem } = item
    let content = caption
    switch (itemKey) {
      case 'bestWins':
      case 'worstLosses':
        delete itemItem.key
        content = _.map(itemItem, i => i.name).join(', ');
        break;
      case 'performanceDelta':
      case 'expectedWins':
      case 'strengthOfSchedule':
      case 'elo_raw':
        content = itemItem
      default:
      // nothing
    }
    return <div className='sqr-box ti'>
      <div>{_.startCase(itemKey)}</div>
      <div className='sqr-box-oth'>
        {content}
      </div>
    </div>
  }

  const ims_insights = () => <ItemMenuSquares menuItems={teamInsights} imsType={_imsTypes.parent} fn_mainContent={fnMainContent} ignoreStartCase={true} />

  return (
    <div>
      {teamReason && div_reason()}
      {ims_insights()}
    </div>
  )
}
